export enum IntermediarySections {
    data = "data",
    telematicData = "telematicData",
    securityenv = "securityenv",
    delegated = "delegated"
}
